import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Sobre from "../views/Sobre.vue";
import Servicos from "../views/Servicos.vue";
import Contato from "../views/Contato.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/sobre",
    name: "Sobre",
    component: Sobre,
  },
  {
    path: "/servicos",
    name: "Servicos",
    component: Servicos,
  },
  {
    path: "/contato",
    name: "Contato",
    component: Contato,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        top: 0,
        behavior: "smooth",
      };
    }
  },
});

export default router;
